// The page address Google Analytics is given: the path and query (the emails' UTMs), never the
// hash (Seán, 2026-11-02, option 1). An email's links put personal parts after the "#": the
// recipient's address (email=, prefillEmail.js), a sign-in ticket (magic=, magicLink.js), an
// unsubscribe token (#unsubscribe/<token>); GA read them into its page addresses and campaigns,
// and personal data mustn't reach GA. Kept out whole, not part by part: GA also reads the hash
// into the campaign's name (utm_campaign=…#register), and its page reports drop the hash anyway
// (the registration funnel is the fullstack's events). A "#" a mail scanner encoded into the
// path (/%23unsubscribe/<token>) is cut off too. fullstack claude/ANALYTICS.md § Reading GA from
// a script; as the fullstack's GA plugin (googleAnalytics.client.js).

// "/%23unsubscribe/<token>" → "/": an encoded "#" and what follows it
const getCleanPath = (path) => String(path || "/").replace(/%23.*$/i, "") || "/";

function getSearch(query) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query || {})) {
    for (const item of [].concat(value ?? "")) params.append(key, item ?? "");
  }
  const search = params.toString();
  return search ? `?${search}` : "";
}

// the current page, at startup (gtag's config)
export function getGaPageLocation() {
  const {origin, pathname, search} = window.location;
  return `${origin}${getCleanPath(pathname)}${search}`;
}

// vue-gtag's page view for a route: its path and query, no hash
export function getGaPageView(to) {
  const path = getCleanPath(to.path);
  const location = `${window.location.origin}${path}${getSearch(to.query)}`;
  return {...(to.name && {page_title: String(to.name)}), page_path: path, page_location: location};
}
